var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReportScripts = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.83333 8.60625V2.83333C2.83333 2.45761 2.98259 2.09728 3.24827 1.8316C3.51394 1.56592 3.87428 1.41667 4.25 1.41667H9.91667C10.1411 1.41612 10.3635 1.46002 10.5709 1.54586C10.7783 1.63169 10.9666 1.75774 11.1251 1.91675L13.6666 4.45825C13.8256 4.61668 13.9516 4.80504 14.0375 5.01245C14.1233 5.21985 14.1672 5.4422 14.1667 5.66667V14.1667C14.1667 14.5424 14.0174 14.9027 13.7517 15.1684C13.4861 15.4341 13.1257 15.5833 12.75 15.5833H10.3771",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.91667 1.41667V4.95833C9.91667 5.14619 9.99129 5.32636 10.1241 5.4592C10.257 5.59204 10.4371 5.66667 10.625 5.66667H14.1667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.54167 11.3333L1.41667 13.4583L3.54167 15.5833",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.375 15.5833L8.5 13.4583L6.375 11.3333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReportScripts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/report-scripts.8331ec84d8dc9d2adeed2dc95bc8341c.svg";